import { NgModule } from "@angular/core";
import { BarGraphComponent } from "./bar-graph.component";

@NgModule({
    exports: [BarGraphComponent],
    declarations: [BarGraphComponent]
})

export class BarGraphModule {
}